import allPages from "app/routers/Routers";
import { flat } from "configs/project";
import { Navigate, useLocation } from "react-router-dom";
import { isExistsCookies } from "utils/cookies";
import { isExistsRoles } from "utils/roles";
import useAuth from "../hooks/useAuth";

const userHasPermission = (pathname, authData, routes) => {
  if (!authData) {
    return false;
  }
  const matched = routes.find((r) => r.path === pathname);
  const isAuthenticated =
    matched && matched.auth && matched.auth.length
      ? matched.auth.includes(authData.role)
      : true;
  return isAuthenticated;
};

export default function AuthGuard({ children }) {
  const { isAuthenticated, authData } = useAuth(); //user
  const { pathname } = useLocation();

  const routes = flat(allPages);

  const hasPermission = userHasPermission(pathname, authData, routes);

  const isAuthenticatedAndCookies =
    isAuthenticated &&
    isExistsCookies() &&
    isExistsRoles(authData.role) &&
    hasPermission;

  return (
    <>
      {isAuthenticatedAndCookies ? (
        children
      ) : (
        <Navigate replace to="/" state={{ from: pathname }} />
      )}
    </>
  );
}
